/**
 * layout 配置
 */

/**
 * 侧边栏最大宽度
 */
export const SIDER_MAX_WIDTH = 260

/**
 * 侧边栏自动收缩宽度
 */
export const SIDER_AUTO_SHRINK_WIDTH = 1000
